import { Link } from "react-router-dom";
import { Heart, Quote, Star, Shield } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

const STORIES = [
  {
    name: "Lena, 14",
    quote: "Ich wurde in der Schule und online fertig gemacht. Ich habe mich hier gemeldet und endlich hat jemand zugehört. Jetzt geht es mir besser.",
    category: "Cybermobbing",
    color: "#FFC4D6",
    outcome: "Hat Hilfe bekommen und das Mobbing wurde gestoppt"
  },
  {
    name: "Max, 12",
    quote: "Jemand hat ein Fake-Profil mit meinem Namen gemacht. Ich wusste nicht, was ich tun soll. Hier haben sie mir erklärt, wie ich es melden kann.",
    category: "Identitätsdiebstahl",
    color: "#A0E8AF",
    outcome: "Das Fake-Profil wurde gelöscht"
  },
  {
    name: "Sarah, 16",
    quote: "Am Anfang hatte ich Angst, es zu melden. Aber alle waren so nett und haben mir geholfen. Ich bin froh, dass ich es gemacht habe.",
    category: "Mobbing in der Schule",
    color: "#BDE0FE",
    outcome: "Gespräch mit Schulleitung, Mobbing wurde angesprochen"
  },
  {
    name: "Tim, 13",
    quote: "In der WhatsApp-Gruppe haben alle über mich gelästert. Mit den Screenshots konnte ich beweisen, was passiert ist.",
    category: "Cybermobbing",
    color: "#F6E05E",
    outcome: "Eltern wurden informiert, Gespräch mit allen Beteiligten"
  },
  {
    name: "Emma, 15",
    quote: "Ich dachte, niemand würde mir glauben. Aber hier wurde ich ernst genommen. Das hat mir so viel bedeutet.",
    category: "Mobbing",
    color: "#FFC4D6",
    outcome: "Vermittlung an Beratungsstelle"
  },
];

export default function Erfahrungen() {
  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      <Header />
      <SEO title="Erfahrungsberichte – Mobbing ueberwunden" description="Echte Erfahrungsberichte von Kindern und Jugendlichen, die Mobbing ueberwunden haben. Du bist nicht allein – Mut machen und Hoffnung geben." path="/erfahrungen" />
      
      <main className="px-6 md:px-12 lg:px-24 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Hero */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-[#FFC4D6]/30 rounded-full flex items-center justify-center mx-auto mb-6">
              <Heart className="w-10 h-10 text-[#591C2E]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Erfahrungsberichte
            </h1>
            <p className="text-lg text-[#718096] max-w-2xl mx-auto">
              Echte Geschichten von Kindern und Jugendlichen, die sich gemeldet haben. 
              Alle Namen wurden geändert, um ihre Privatsphäre zu schützen.
            </p>
          </div>

          {/* Important Note */}
          <div className="bg-[#A0E8AF]/10 border border-[#A0E8AF]/30 rounded-2xl p-6 mb-10">
            <div className="flex items-start gap-4">
              <Shield className="w-6 h-6 text-[#1A4731] flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-[#1A4731] mb-1">Hinweis zur Privatsphäre</h3>
                <p className="text-[#718096] text-sm">
                  Alle Geschichten basieren auf echten Fällen, wurden aber anonymisiert und leicht verändert, 
                  um die Identität der Betroffenen zu schützen.
                </p>
              </div>
            </div>
          </div>

          {/* Stories Grid */}
          <div className="space-y-6 mb-12">
            {STORIES.map((story, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 md:p-8 shadow-soft border border-gray-100"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: `${story.color}40` }}
                  >
                    <Quote className="w-5 h-5" style={{ color: story.color }} />
                  </div>
                  <div>
                    <h3 className="font-bold text-[#2D3748]">{story.name}</h3>
                    <span 
                      className="text-xs px-2 py-1 rounded-full"
                      style={{ backgroundColor: `${story.color}30`, color: story.color }}
                    >
                      {story.category}
                    </span>
                  </div>
                </div>
                
                <blockquote className="text-lg text-[#718096] italic mb-4 pl-4 border-l-4" style={{ borderColor: story.color }}>
                  "{story.quote}"
                </blockquote>
                
                <div className="flex items-center gap-2 text-sm">
                  <Star className="w-4 h-4 text-[#F6E05E]" fill="#F6E05E" />
                  <span className="text-[#718096]">{story.outcome}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Stats */}
          <div className="bg-gradient-to-br from-[#E6FFFA] to-[#FFF5F7] rounded-2xl p-8 mb-8">
            <h3 className="text-xl font-bold text-[#2D3748] mb-6 text-center" style={{ fontFamily: 'Nunito' }}>
              Gemeinsam stark 💪
            </h3>
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-bold text-[#A0E8AF]">100+</div>
                <div className="text-sm text-[#718096]">Kindern geholfen</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#BDE0FE]">24h</div>
                <div className="text-sm text-[#718096]">Reaktionszeit</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#FFC4D6]">100%</div>
                <div className="text-sm text-[#718096]">Vertraulich</div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h3 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              Deine Geschichte zählt auch!
            </h3>
            <p className="text-[#718096] mb-6">
              Trau dich - wir sind für dich da, genau wie für alle anderen.
            </p>
            <Link 
              to="/melden"
              className="inline-flex items-center justify-center gap-2 bg-[#A0E8AF] text-[#1A4731] font-bold px-8 py-4 rounded-full hover:bg-[#86D696] transition-all text-lg"
            >
              Jetzt melden
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
